import { render, staticRenderFns } from "./WorkTempList.vue?vue&type=template&id=195d0dc0&scoped=true&"
import script from "./WorkTempList.vue?vue&type=script&lang=js&"
export * from "./WorkTempList.vue?vue&type=script&lang=js&"
import style0 from "./WorkTempList.vue?vue&type=style&index=0&id=195d0dc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d0dc0",
  null
  
)

export default component.exports